export const fetchCandidatess = (BeURL, filterOptions, setCandidates, setTotalPages, setTotalCandidates, setLoading, setShowSearchOptions, showAlert) => {
    fetch(`${BeURL}/advance-filter`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(filterOptions)
    })
        .then(res => res.json())
        .then(data => {
            // setShowSearchOptions(true)
            setLoading(false)
            if (data.success) {
                setCandidates(data.candidates)
                setTotalPages(data.totalPages)
                setTotalCandidates(data.totalCandidates)
                // window.location.href="#list-candidates"
            }
            else { showAlert(data.message) }

        })
        .catch(err => {
            setShowSearchOptions(false)
            setLoading(false)
            console.log("Error in Advance filter functionality:", err)
        })
}

export const fetchNewCandidateProfile = async (qs, ctrl, setPagination, setNewUsers, BeURL, showAlert, setLoading, filters) => {


    try {
        setLoading(true);

        const res = await fetch(`${BeURL}/get-newuser?${qs}`, {
            credentials: "include",
            signal: ctrl.signal,
        });
        const data = await res.json();
        if (data?.success) {

            setNewUsers(Array.isArray(data.newUsers) ? data.newUsers : []);
            setPagination(
                data.pagination ?? {
                    page: filters.page,
                    perPage: filters.perPage,
                    totalPages: 1,
                    total: Array.isArray(data.newUsers) ? data.newUsers.length : 0,
                }
            );
        }
    } catch (err) {
        console.log("Error in Search functionality:", err)
    }
}